import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { _FixedAssetItemByChekedReport } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectFixedAsset } from "../FixedAsset/SelectFixedAsset";
import { AccountEditor } from "../../../../../../editor/AccountEditor";
import { SelectStoreEditor } from "../../SelectStore.editor";
import { FixedStateConstants } from "./FixedStateConstants";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { SelectFunctionalID } from "../../../../../../admin/configuracion/functionalID/SelectFunctionalID";
import { CostingCenterSelect } from "../../../../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { SelectBusinessCore } from "../../../../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { BasicSwitch } from "../../../../../../theme/Component/BasicSwitch";
import { EditorFixedAssetItem } from "../EditorFixedAssetItem";
import { InputDate } from "../../../../../../theme/Input/InputDate";
import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { FixedAssetItemsCheckedReportEditor } from "./FixedAssetItemsCheckedReportEditor";
import { FixedAssetItemStatesForDownloadItems } from "../FixedAssetitemStatesForDownloaditems";
import { DocumentViewer } from "../../../../../../theme/Component/DocumentViewer";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";



export const FixedAssetItemByChekedReport = () => {

    const chekedreport = useDataBean(_FixedAssetItemByChekedReport);

    const [obj, setObj] = useState<any>({})

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [IDAccount, setIDAccount] = useState<number>(null)
    const [storeID, setstoreID] = useState<number>(null)
    const [state, setState] = useState<number>(null)
    const [form, setform] = useState<any>({
        Name: null,
        asset: null,
        placa: null
    })

    const paginador = usePaginator();
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [documentos, setDocumentos] = useState<any>([]);
    const [modalactivofijo, setModalactivofijo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalDocumento, setModalDocumento] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalretiraractivofijo, setModalreiraractivofijo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalasignaractivofijo, setModalasignaractivofijo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page, 15])

    const getLista = () => {

        chekedreport.instance.getFixedAssetItemsCheckedReport(form.asset, IDAccount, storeID, state, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    setLista(resp.List)

                }
            }
        )

    }

    const create = () => {
        chekedreport.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        chekedreport.deleteItemVoid(chekedreport.bean.IDItem).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        chekedreport.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }



    const veractivo = () => {
        setModalactivofijo({ ...modalactivofijo, "view": true });
    }

    const retiraractivofijo = () => {
        setModalreiraractivofijo({ ...modalretiraractivofijo, "view": true, name: "Retirar activo dijo de controlados" });
        chekedreport.setBean({});
    }

    const asignaractivofijo = () => {
        chekedreport.setBean({});
        setModalasignaractivofijo({ ...modalasignaractivofijo, "view": true, name: "Asignar activo fijo a responsable" });
    }

    const agreegaractivo = () => {
        chekedreport.instance.addFixedAssetItemToControlled(chekedreport.bean.IDFixedAssetItem, chekedreport.bean.FromDate, chekedreport.bean.IDResponsible, _single.getAccountID()).then(
            (resp: any) => {
                if (resp.MsgList) {
                    setDocumentos(resp.DocumentURL);
                    toast.success('Operación realizada exitosamente.');
                    setModalDocumento({ ...modalDocumento, "view": true });
                    setModalactivofijo({ ...modalactivofijo, "view": false });
                } else {
                    toast.warning("No se encontro documento");
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const retiraractivo = () => {
        chekedreport.instance.removeFixedAssetItemToControlled(chekedreport.bean.IDFixedAssetItem, chekedreport.bean.FromDate, chekedreport.bean.itemDownCase, chekedreport.bean.Observations, _single.getAccountID()).then(
            (resp: any) => {
                if (resp.MsgList) {
                    setDocumentos(resp.DocumentURL);
                    toast.success('Operación realizada exitosamente.');
                    setModalDocumento({ ...modalDocumento, "view": true });
                    setModalreiraractivofijo({ ...modalretiraractivofijo, "view": false });
                } else {
                    toast.warning("No se encontro documento");
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const asignaractivo = () => {
        if (!obj.IDFixedAssetItem) {
            toast.error("Activo fijo obligatorio");
            return
        }
        if (!obj.FromDate) {
            toast.error("Fecha obligatorio");
            return
        }
        if (!obj.IDResponsible) {
            toast.error("Responsable obligatorio");
            return
        }
        if (!obj.IDStore) {
            toast.error("Bodega obligatoria");
            return
        }
        if (!obj.IDLnFunctionalID) {
            toast.error("Dependencia obligatoria");
            return
        }

        chekedreport.instance.assignFixedAssetItemControlledToResponsible(obj.IDFixedAssetItem, obj.FromDate, obj.IDResponsible, obj.IDStore, obj.IDLnFunctionalID, _single.getAccountID()).then(
            (resp: any) => {
                if (resp.MsgList) {
                    setDocumentos(resp.DocumentURL);
                    toast.success('Operación realizada exitosamente.');
                    getLista();
                    // setModalDocumento({ ...modalDocumento, "view": true });
                    setModalasignaractivofijo({ ...modalasignaractivofijo, "view": false });
                } else {
                    toast.warning("No se encontro documento");
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDItem', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Placa', property: 'TicketCode', visible: true },
        { title: 'Disponibilidad', property: 'StateName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Responsable', property: 'ResponsibleName', visible: true },
        // { title: 'Línea/Grupo de Activos', property: 'FixedAssetLineName', visible: true },
        { title: 'Ubicación', property: 'StoreName', visible: true },
        { title: 'Estado del Bien', property: 'FixedAssetStateName', visible: true },
        { title: 'Serial', property: 'SerialNumber', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Numero Documento', property: 'Consecutive', visible: true },
        { title: 'Controlado', property: 'Checked', visible: true },
        { title: 'Cuentas de Orden', property: 'OrderAccountant', visible: true },
        { title: 'Causa de la Baja', property: 'ItemDownCauseName', visible: true },
        { title: 'Tiempo Depreciación', property: 'DepreciationTime', visible: true },
        { title: 'Tiempo Depreciación Fiscal', property: 'FiscalDepreciationTime', visible: true },
        { title: 'Adición NIIF', property: 'NiifAdditionValue', visible: true },
        { title: 'Adición Fiscal', property: 'FiscalAdditionValue', visible: true },
        { title: 'Dependencia', property: 'IDLnFunctionalID', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterCode', visible: true },
        { title: 'Unidad de Negocio', property: 'IDBusinessCore', visible: true },
        { title: 'Reconocimiento NIIF Inicial', property: 'NiifInitialValue', visible: true },
        { title: 'Valor Residual', property: 'ResidualValue', visible: true },
        { title: 'Usar Cuenta Servicio en Ops NIIF', property: 'UseBrandIDForAllOps', visible: true },
        { title: 'No depreciar ni amortizar', property: 'NotDepreciateOrAmortize', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            // { titulo: 'Agregar Activo Fijo a Controlado', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalactivofijo({ ...modalactivofijo, "view": true }) } },
            // { titulo: 'Retirar Activo Fijo de controlados', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalreiraractivofijo({ ...modalretiraractivofijo, "view": true }) } },
            // { titulo: 'Asignar Activo Fijo a Responsable', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalasignaractivofijo({ ...modalasignaractivofijo, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${chekedreport.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Catálogo de Activos Fijos Controlados">
            <div className="row">
                <div className="col-md-4">
                    <label>Activo Fijo</label>
                    <SelectFixedAsset render={form.Name} idSelector={form.asset} onChange={(e) => { setform({ ...form, "asset": e.IDFixedAsset, "Name": e.Description }) }} label=" " returnType="Object" />
                </div>
                <div className="col-md-4">
                    <AccountEditor label="Responsable" idAccount={IDAccount} onChange={(e: any) => { setIDAccount(e.IDAccount) }} />
                </div>
                <div className="col-md-4">
                    <SelectStoreEditor label='Almacén/Bodega' idSelector={storeID} onChange={(e) => { setstoreID(e.IDStore) }} />
                </div>
                <div className="col-md-4">
                    <FixedStateConstants idSelector={state} onChange={(e) => { setState(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="" eventClick={getLista}>Buscar*</BasicButton>
                </div>
                <div className="col-md-12">
                    <div className="row mt-2">
                        <div className="col-md-4">
                            <BasicButton icon="" eventClick={veractivo}>Agregar Activo Fijo a Controlado*</BasicButton>
                        </div>
                        <div className="col-md-4">
                            <BasicButton icon="" eventClick={retiraractivofijo}>Retirar Activo Fijo de controlados*</BasicButton>
                        </div>
                        <div className="col-md-4">
                            <BasicButton icon="" eventClick={asignaractivofijo}>Asignar Activo Fijo a Responsable*</BasicButton>
                        </div>
                    </div>

                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={chekedreport.setBean} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectFunctionalID label='Dependencia' functionalIDLn={chekedreport.bean.IDLnFunctionalID} onChange={(e: any) => { chekedreport.setBean({ ...chekedreport.bean, "IDLnFunctionalID": e.IDLn }) }} />
                            </div>
                            <div className="col-md-6">
                                <CostingCenterSelect label="Centro de Costo" idSelector={chekedreport.bean.CostingCenterCode} onChange={(e) => { chekedreport.setBean({ ...chekedreport.bean, "CostingCenterCode": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBusinessCore label="Unidad de Negocio" idSelector={chekedreport.bean.IDBusinessCore} onChange={(e) => { chekedreport.setBean({ ...chekedreport.bean, "IDBusinessCore": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Serial</label>
                                <input type="text" name='SerialNumber' className='form-control' value={chekedreport.bean.SerialNumber} onChange={chekedreport.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Causa de la Baja</label>
                                <input type="text" name='ItemDownCause' className='form-control' value={chekedreport.bean.ItemDownCause} onChange={chekedreport.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Tiempo Depreciación</label>
                                <input type="text" name='DepreciationTime' className='form-control' value={chekedreport.bean.DepreciationTime} onChange={chekedreport.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Tiempo Depreciación Fiscal</label>
                                <input type="text" name='FiscalDepreciationTime' className='form-control' value={chekedreport.bean.FiscalDepreciationTime} onChange={chekedreport.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Adición NIIF</label>
                                <input type="text" name='NiifAdditionValue' className='form-control' value={chekedreport.bean.NiifAdditionValue} onChange={chekedreport.handleChange} />
                            </div>

                            <div className="col-md-6">
                                <label>Adición Fiscal</label>
                                <input type="text" name='FiscalAdditionValue' className='form-control' value={chekedreport.bean.FiscalAdditionValue} onChange={chekedreport.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Reconocimiento NIIF Inicial</label>
                                <input type="text" name='NiifInitialValue' className='form-control' value={chekedreport.bean.NiifInitialValue} onChange={chekedreport.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor Residual</label>
                                <input type="text" name='ResidualValue' className='form-control' value={chekedreport.bean.ResidualValue} onChange={chekedreport.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Usar Cuenta Servicio en Ops NIIF" estado={chekedreport.bean.UseBrandIDForAllOps} eventChange={(e: any) => { chekedreport.setBean({ ...chekedreport.bean, "UseBrandIDForAllOps": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="No depreciar ni amortizar" estado={chekedreport.bean.NotDepreciateOrAmortize} eventChange={(e: any) => { chekedreport.setBean({ ...chekedreport.bean, "NotDepreciateOrAmortize": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">

                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={chekedreport.bean.Observations} onChange={chekedreport.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalDocumento} updateModal={setModalDocumento}>
                        <>
                            <div className="col-md-12 mt-4">
                                <DocumentViewer list={documentos} />
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalactivofijo} updateModal={setModalactivofijo} eventModal={agreegaractivo}>
                        <div className="row">
                            <div className="col-md-12">
                                <EditorFixedAssetItem idSelector={chekedreport.bean.IDFixedAssetItem} label="Activo Fijo" onChange={(e) => { chekedreport.setBean({ ...chekedreport.bean, IDFixedAssetItem: e.IDItem, Name: e.Name }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="from" label="Fecha" value={chekedreport.bean.FromDate} setDate={(e: any) => { chekedreport.setBean({ ...chekedreport.bean, "FromDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={chekedreport.bean.IDResponsible} label="Responsable" onChange={(acc: any) => { chekedreport.setBean({ ...chekedreport.bean, "IDResponsible": acc.IDAccount }); }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalretiraractivofijo} updateModal={setModalreiraractivofijo} eventModal={retiraractivo}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Activo a retirar</label>
                                <FixedAssetItemsCheckedReportEditor render={chekedreport.bean.FixedName} idSelector={chekedreport.bean.IDFixedAssetItem} onChange={(e) => { chekedreport.setBean({ ...chekedreport.bean, "IDFixedAssetItem": e.IDItem, "FixedName": e.Name }) }} label=" " returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="FromDate" label="Fech" value={chekedreport.bean.FromDate} setDate={(e: any) => { chekedreport.setBean({ ...chekedreport.bean, "FromDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <FixedAssetItemStatesForDownloadItems idSelector={chekedreport.bean.itemDownCase} onChange={(acc: any) => { chekedreport.setBean({ ...chekedreport.bean, "itemDownCase": acc }); }} />
                            </div>
                            <div className="col-md-12">

                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={chekedreport.bean.Observations} onChange={chekedreport.handleChange} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalasignaractivofijo} updateModal={setModalasignaractivofijo} eventModal={asignaractivo}>
                        <div className="row">
                            <div className="col-md-12">
                                <EditorFixedAssetItem StateActive={2} idSelector={obj.IDFixedAssetItem} label="Activo Fijo" onChange={(e) => { setObj({ ...obj, IDFixedAssetItem: e.IDItem, Name: e.Name }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="from" label="Fecha" value={obj.FromDate} setDate={(e: any) => { setObj({ ...obj, "FromDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={obj.IDResponsible} label="Responsable" onChange={(acc: any) => { setObj({ ...obj, "IDResponsible": acc.IDAccount }); }} />
                            </div>
                            <div className="col-md-6">
                                <SelectStoreEditor label='Almacén/Bodega' idSelector={obj.IDStore} onChange={(e) => { setObj({ ...obj, IDStore: e.IDStore }) }} />
                            </div>
                            <div className="col-md-6">
                                <label >Dependencia</label>
                                <SelectFunctionalID onChange={(e) => { setObj({ ...obj, IDLnFunctionalID: e.IDLn }) }} label="" functionalIDLn={obj.IDLnFunctionalID} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {chekedreport.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}